export const SQL = `
WITH users_scored AS (
  SELECT
    u.external_id,
    CASE
      WHEN u.attribution ~ '^\\d+$' THEN 'meta'
      WHEN u.attribution ILIKE '%google%' THEN 'google'
      WHEN u.attribution ILIKE '%facebook%' OR u.attribution ILIKE '%meta%' OR u.attribution ILIKE '%instagram%' THEN 'meta'
      WHEN u.attribution ILIKE '%linkedin%' THEN 'linkedin'
      WHEN u.attribution ILIKE '%article%' OR u.attribution ILIKE '%ft%' OR u.attribution ILIKE '%press%' OR u.attribution ILIKE '%news%' THEN 'press'
      WHEN u.attribution ILIKE '%conference%' OR u.attribution ILIKE '%summit%' OR u.attribution ILIKE '%expo%' OR u.attribution ILIKE '%event%' OR u.attribution ILIKE '%wealthpoint%' OR u.attribution ILIKE '%fpa%' OR u.attribution ILIKE '%ifp%' THEN 'conference'
      WHEN u.attribution ILIKE '%referral%' OR u.attribution ILIKE '%word of mouth%' OR u.attribution ILIKE '%recommend%' OR u.attribution ILIKE '%colleague%' OR u.attribution ILIKE '%friend%' OR u.attribution ILIKE '%social media%' THEN 'referral'
      WHEN u.attribution ILIKE '%work%' OR u.attribution ILIKE '%employer%' OR u.attribution ILIKE '%firm%' OR u.attribution ILIKE '%company%' THEN 'workplace'
      WHEN u.attribution ILIKE '%online%' OR u.attribution ILIKE '%search%' OR u.attribution ILIKE '%web%' THEN 'organic_search'
      WHEN u.attribution ILIKE '%demo%' THEN 'demo'
      WHEN u.attribution IS NULL OR TRIM(u.attribution) = '' THEN 'unknown'
      ELSE 'other'
    END AS attribution_category,
    (COALESCE(demo.demo_count, 0) > 0) AS had_demo,
    CASE
      WHEN cb.subscription_started_date_utc IS NOT NULL
        AND cb.subscription_started_date_utc > u.created_at_utc
        AND cb.billing_plan = 'pro'  THEN 'Pro'
      WHEN cb.subscription_started_date_utc IS NOT NULL
        AND cb.subscription_started_date_utc > u.created_at_utc
        AND cb.billing_plan = 'plus' THEN 'Plus'
      WHEN COALESCE(t.transcript_count, 0) > 0
        OR  COALESCE(s.synopsis_count,  0) > 0 THEN 'Free (active)'
      ELSE 'Free (inactive)'
    END AS outcome,
    ur.role AS user_role,
    to_char(u.created_at_utc, 'YYYY-MM') AS created_month,
    comp.country_code AS country_code,
    CASE
      WHEN company_users.marloo_active_user_count = 1 THEN '1'
      WHEN company_users.marloo_active_user_count BETWEEN 2 AND 10 THEN '2-10'
      WHEN company_users.marloo_active_user_count BETWEEN 11 AND 50 THEN '11-50'
      ELSE '50+'
    END AS company_size_bucket,
    (CASE cb.billing_plan WHEN 'pro' THEN 3 WHEN 'plus' THEN 2 WHEN 'free' THEN 1 ELSE 0 END) * 1000
      + (CASE
           WHEN cb.subscription_started_date_utc IS NOT NULL
             AND cb.subscription_started_date_utc > u.created_at_utc
             AND cb.billing_plan IN ('plus', 'pro') THEN 500
           ELSE 0
         END)
      + COALESCE(s.synopsis_count, 0) AS dedup_score
  FROM public.user_roles ur
  JOIN public.users u ON u.external_id = ur.user_external_id AND ur.status = 'active'
  LEFT JOIN public.company_billing cb ON cb.company_external_id = ur.company_external_id
  LEFT JOIN public.companies comp ON comp.external_id = ur.company_external_id
  LEFT JOIN LATERAL (
    SELECT COUNT(*) AS transcript_count
    FROM public.meeting_transcription mt
    JOIN public.meeting m ON m.external_id = mt.meeting_external_id
    WHERE mt.user_external_id = ur.user_external_id
      AND mt.company_external_id = ur.company_external_id
      AND mt.deleted_date_utc IS NULL
      AND m.is_demo = false
      AND m.deleted_date_utc IS NULL
  ) t ON TRUE
  LEFT JOIN LATERAL (
    SELECT COUNT(*) AS synopsis_count
    FROM public.meeting_synopsis ms
    JOIN public.meeting m ON m.external_id = ms.meeting_external_id
    WHERE ms.user_external_id = ur.user_external_id
      AND ms.company_external_id = ur.company_external_id
      AND m.is_demo = false
      AND m.deleted_date_utc IS NULL
  ) s ON TRUE
  LEFT JOIN LATERAL (
    SELECT COUNT(*) AS demo_count
    FROM reporting.demo_user du
    WHERE du.user_external_id = ur.user_external_id
  ) demo ON TRUE
  LEFT JOIN LATERAL (
    SELECT COUNT(*) AS marloo_active_user_count
    FROM public.user_roles ur2
    WHERE ur2.company_external_id = ur.company_external_id
      AND ur2.status = 'active'
  ) company_users ON TRUE
  WHERE u.email NOT LIKE '%@gomarloo.com'
),
deduped AS (
  SELECT DISTINCT ON (external_id)
    attribution_category,
    had_demo,
    outcome,
    user_role,
    created_month,
    country_code,
    company_size_bucket
  FROM users_scored
  ORDER BY external_id, dedup_score DESC
)
SELECT
  attribution_category,
  had_demo,
  outcome,
  user_role,
  created_month,
  country_code,
  company_size_bucket,
  COUNT(*) AS user_count
FROM deduped
GROUP BY 1, 2, 3, 4, 5, 6, 7
ORDER BY 1, 2, 3, 4, 5, 6, 7
`;

export const WORD_SQL = `
WITH users_scored AS (
  SELECT
    u.external_id,
    u.attribution AS attribution_raw,
    (COALESCE(demo.demo_count, 0) > 0) AS had_demo,
    ur.role AS user_role,
    to_char(u.created_at_utc, 'YYYY-MM') AS created_month,
    comp.country_code AS country_code,
    CASE
      WHEN company_users.marloo_active_user_count = 1 THEN '1'
      WHEN company_users.marloo_active_user_count BETWEEN 2 AND 10 THEN '2-10'
      WHEN company_users.marloo_active_user_count BETWEEN 11 AND 50 THEN '11-50'
      ELSE '50+'
    END AS company_size_bucket,
    (CASE cb.billing_plan WHEN 'pro' THEN 3 WHEN 'plus' THEN 2 WHEN 'free' THEN 1 ELSE 0 END) * 1000
      + COALESCE(s.synopsis_count, 0) AS dedup_score
  FROM public.user_roles ur
  JOIN public.users u ON u.external_id = ur.user_external_id AND ur.status = 'active'
  LEFT JOIN public.company_billing cb ON cb.company_external_id = ur.company_external_id
  LEFT JOIN public.companies comp ON comp.external_id = ur.company_external_id
  LEFT JOIN LATERAL (
    SELECT COUNT(*) AS synopsis_count
    FROM public.meeting_synopsis ms
    WHERE ms.user_external_id = ur.user_external_id
      AND ms.company_external_id = ur.company_external_id
  ) s ON TRUE
  LEFT JOIN LATERAL (
    SELECT COUNT(*) AS demo_count
    FROM reporting.demo_user du
    WHERE du.user_external_id = ur.user_external_id
  ) demo ON TRUE
  LEFT JOIN LATERAL (
    SELECT COUNT(*) AS marloo_active_user_count
    FROM public.user_roles ur2
    WHERE ur2.company_external_id = ur.company_external_id
      AND ur2.status = 'active'
  ) company_users ON TRUE
  WHERE u.email NOT LIKE '%@gomarloo.com'
    AND u.attribution IS NOT NULL
    AND TRIM(u.attribution) <> ''
    AND u.attribution !~ '^\\d+$'
),
deduped AS (
  SELECT DISTINCT ON (external_id)
    attribution_raw,
    had_demo,
    user_role,
    created_month,
    country_code,
    company_size_bucket
  FROM users_scored
  ORDER BY external_id, dedup_score DESC
)
SELECT
  attribution_raw,
  had_demo,
  user_role,
  created_month,
  country_code,
  company_size_bucket
FROM deduped
`;

export type WordRow = {
  attribution_raw: string;
  had_demo: boolean;
  user_role: string | null;
  created_month: string;
  country_code: string | null;
  company_size_bucket: string;
};

export function mapWordRows(columns: string[], rows: unknown[][]): WordRow[] {
  const idx: Record<string, number> = {};
  columns.forEach((c, i) => { idx[c] = i; });
  const get = (row: unknown[], k: string): unknown =>
    idx[k] !== undefined ? row[idx[k] as number] : undefined;
  const str = (v: unknown): string => (v == null ? "" : String(v));
  const strNull = (v: unknown): string | null => (v == null ? null : String(v));
  const bool = (v: unknown): boolean => v === true || v === "t" || v === "true";
  return rows.map((r) => ({
    attribution_raw: str(get(r, "attribution_raw")),
    had_demo: bool(get(r, "had_demo")),
    user_role: strNull(get(r, "user_role")),
    created_month: str(get(r, "created_month")),
    country_code: strNull(get(r, "country_code")),
    company_size_bucket: str(get(r, "company_size_bucket")),
  }));
}

export type AttrRow = {
  attribution_category: string;
  had_demo: boolean;
  outcome: string;
  user_role: string | null;
  created_month: string;
  country_code: string | null;
  company_size_bucket: string;
  user_count: number;
};

export function mapAttrRows(columns: string[], rows: unknown[][]): AttrRow[] {
  const idx: Record<string, number> = {};
  columns.forEach((c, i) => { idx[c] = i; });
  const get = (row: unknown[], k: string): unknown =>
    idx[k] !== undefined ? row[idx[k] as number] : undefined;
  const str = (v: unknown): string => (v == null ? "" : String(v));
  const strNull = (v: unknown): string | null => (v == null ? null : String(v));
  const bool = (v: unknown): boolean => v === true || v === "t" || v === "true";
  const num = (v: unknown): number => {
    if (v == null) return 0;
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };
  return rows.map((r) => ({
    attribution_category: str(get(r, "attribution_category")),
    had_demo: bool(get(r, "had_demo")),
    outcome: str(get(r, "outcome")),
    user_role: strNull(get(r, "user_role")),
    created_month: str(get(r, "created_month")),
    country_code: strNull(get(r, "country_code")),
    company_size_bucket: str(get(r, "company_size_bucket")),
    user_count: num(get(r, "user_count")),
  }));
}
